<template>
    <o-modal name="firstLogin" :closable="false">
        <div class="o-modal__row">
            <h2 class="a-title m-card__title">
                Otrzymałeś darmowy dostęp do Agriibazy
                <span v-if="activeSubscriptionData.activeTo"
                    >do dnia
                    {{
                        this.$dayjs(activeSubscriptionData.activeTo).format(
                            'DD.MM.YYYY'
                        )
                    }}</span
                >
            </h2>
        </div>

        <slot name="actions"
            ><div class="o-modal__row">
                <a-button @click="$store.dispatch('modalHide', 'firstLogin')"
                    >Rozumiem</a-button
                >
            </div>
        </slot>
    </o-modal>
</template>
<script>
export default {
    name: 'FirstLoginModal',
    computed: {
        activeSubscriptionData() {
            return this.$store.getters['subscriptions/activeSubscription']
        }
    }
}
</script>
